import { AUSENTE } from '@/features/financeiro/utils/formatters'

import type { EstadoParcela, SituacaoFinanceira } from '../domain/financeiro'

// Só rótulos de exibição. A regra da Situação financeira e o estado de cada
// parcela vêm calculados do api.

const SITUACAO: Record<SituacaoFinanceira, string> = {
  SEM_COBRANCA: 'Sem cobrança',
  EM_DIA: 'Em dia',
  ATRASADA: 'Atrasada',
  PAGA: 'Paga',
}

export const rotuloDaSituacao = (situacao: SituacaoFinanceira) =>
  SITUACAO[situacao]

// Uma parcela ignorada mostra o próprio status (cancelada, renegociada, perdida),
// que é o que explica ao usuário por que ela não conta.
const IGNORADA: Record<string, string> = {
  CANCELADO: 'Cancelada',
  RENEGOCIADO: 'Renegociada',
  PERDIDO: 'Perdida',
}

export function rotuloDaParcela(
  estado: EstadoParcela,
  status: string | null,
): string {
  if (estado === 'IGNORADA') return (status && IGNORADA[status]) || 'Ignorada'
  if (estado === 'RECEBIDA') return 'Recebida'

  // Cópia local ainda não preenchida: o job a preenche em minutos.
  if (status === null) return 'Aguardando sincronização'

  const parcial = status === 'RECEBIDO_PARCIAL'
  if (estado === 'ATRASADA')
    return parcial ? 'Atrasada (recebida em parte)' : 'Atrasada'
  return parcial ? 'Recebida em parte' : 'Em aberto'
}

const METODOS: Record<string, string> = {
  BOLETO_BANCARIO: 'Boleto',
  PIX_PAGAMENTO_INSTANTANEO: 'Pix',
  COBRANCA_PIX: 'Cobrança Pix',
  CARTAO_CREDITO: 'Cartão de crédito',
  CARTAO_DEBITO: 'Cartão de débito',
  DINHEIRO: 'Dinheiro',
  TRANSFERENCIA_BANCARIA: 'Transferência bancária',
  DEPOSITO_BANCARIO: 'Depósito bancário',
  CHEQUE: 'Cheque',
  LINK_PAGAMENTO: 'Link de pagamento',
  DEBITO_AUTOMATICO: 'Débito automático',
}

// Os tipos comuns têm rótulo legível; os demais aparecem com o código cru.
export function rotuloDoMetodoPagamento(codigo: string | null): string {
  if (!codigo) return AUSENTE
  return METODOS[codigo] ?? codigo
}

export const CODIGOS_COM_ROTULO = Object.keys(METODOS)
